module.exports = __webpack_public_path__ + "static/media/juegos-de-antano-min.a2a81f80.png";